import { Trans } from "@lingui/react/macro";
import { observable } from "mobx";
import { useEffect, useState } from "react";

import { NameFields, NameFieldsModel } from "../../components/name-fields";
import { Button } from "../../components/ui-kit/button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "../../components/ui-kit/dialog";
import { splitNameArray } from "../../utils/names";

export function NameEditDialog({
  open,
  onOpenChange,
  data,
  onSave,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data: Record<string, any>;
  onSave: (fields: Record<string, any>) => void;
}) {
  const [draft] = useState(() =>
    observable<NameFieldsModel>({
      given_name: null,
      family_name: null,
      middle_names: null,
      name_particle: null,
      additional_family_names: null,
      name_suffix: null,
      title_before: null,
      title_after: null,
      name_order_given_first: true,
    }),
  );

  useEffect(() => {
    if (open) {
      Object.assign(draft, {
        given_name: data.given_name,
        family_name: data.family_name,
        middle_names: data.middle_names?.join(" ") ?? null,
        name_particle: data.name_particle ?? null,
        additional_family_names:
          data.additional_family_names?.join(" ") ?? null,
        name_suffix: data.name_suffix ?? null,
        title_before: data.title_before ?? null,
        title_after: data.title_after ?? null,
        name_order_given_first: data.name_order_given_first ?? true,
      } satisfies NameFieldsModel);
    }
  }, [open, data, draft]);

  const save = () => {
    onSave({
      ...draft,
      middle_names: splitNameArray(draft.middle_names),
      additional_family_names: splitNameArray(draft.additional_family_names),
    });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange} width="42rem">
      <DialogHeader>
        <Trans>Edit name</Trans>
      </DialogHeader>
      <DialogBody>
        <NameFields model={draft} />
      </DialogBody>
      <DialogFooter>
        <Button onClick={() => onOpenChange(false)}>
          <Trans>Cancel</Trans>
        </Button>
        <Button variant="primary" onClick={save}>
          <Trans>Save</Trans>
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
